<template>
  <div id="app">
    <MainNavigation :currentComponent="currentComponent"
                    :selectedDate="selectDate"
                    @toggle-settings="currentComponent = 'settings'"
                    @toggle-tags="currentComponent = 'tags'"
                    @toggle-stats="currentComponent = 'stats'"
                    @toggle-timeline="currentComponent = 'timeline'"
                    @setSelectedDate="setSelectedDate"/>
    <Settings v-if="currentComponent === 'settings'"/>
    <Tags v-else-if="currentComponent === 'tags'"/>
    <Stats v-else-if="currentComponent === 'stats'" :date="selectDate"/>
    <WorkLogs v-else :date="selectDate"/>
    <GoogleDriveBackup v-show="currentComponent === 'settings'"/>
  </div>
</template>

<script>
import MainNavigation from './components/MainNavigation.vue'
import WorkLogs from './components/WorkLogs.vue'
import Settings from './components/Settings.vue'
import Tags from './components/Tags.vue'
import Stats from './components/Stats.vue'
import GoogleDriveBackup from '@/components/GoogleDriveBackup.vue';

export default {
  name: 'app',
  data: function() {
     return {
       settingsOpen: false,
       currentComponent: 'timeline',
       selectDate: new Date()
     }
  },
  components: {
    GoogleDriveBackup,
      MainNavigation,
      WorkLogs,
      Settings,
      Tags,
      Stats
  },
  methods: {
      setSelectedDate: function (selectedDate) {
        this.selectDate = selectedDate;
      }
  }
}
</script>

<style>

</style>
